import { render, staticRenderFns } from "./SeveranceView.vue?vue&type=template&id=b0601338"
import script from "./SeveranceView.vue?vue&type=script&lang=js"
export * from "./SeveranceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports